export const is: (array: unknown) => array is unknown[] | readonly unknown[] = Array.isArray

export const isOfType = <T>(array: unknown, predicate: (value: unknown) => value is T): array is T[] => is(array) && array.every(predicate)
